import React, { useEffect, useMemo, useState } from 'react';
import { Select, Typography } from 'antd';
import { getBotConversations } from '../../services/api/bots';

const { Text } = Typography;

function chatTypeLabel(chatType) {
  if (chatType === 'private') return 'DM';
  if (chatType === 'supergroup') return 'Supergroup';
  if (chatType === 'channel') return 'Channel';
  if (chatType === 'group') return 'Group';
  return 'Chat';
}

function conversationLabel(conversation) {
  const title =
    conversation.chat_title ||
    (conversation.chat_type === 'private' && conversation.participants?.[0]) ||
    conversation.platform_chat_id;
  const typeLabel = chatTypeLabel(conversation.chat_type);
  return `${title} (${typeLabel}, ${conversation.platform_chat_id})`;
}

export default function BotAllowedChatIdsField({
  value,
  onChange,
  botId,
  disabled,
  placeholder = 'Add chat IDs',
}) {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!botId) {
      setConversations([]);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    getBotConversations(botId)
      .then((rows) => {
        if (!cancelled) setConversations(rows || []);
      })
      .catch(() => {
        if (!cancelled) setConversations([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [botId]);

  const options = useMemo(
    () =>
      conversations.map((c) => ({
        value: c.platform_chat_id,
        label: conversationLabel(c),
      })),
    [conversations]
  );

  return (
    <div>
      <Select
        mode="tags"
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        tokenSeparators={[',', ' ']}
        disabled={disabled}
        loading={loading}
        optionFilterProp="label"
        style={{ width: '100%' }}
      />
      {botId && conversations.length > 0 && (
        <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
          Pick from chats the bot has already seen, or type an id manually.
        </Text>
      )}
    </div>
  );
}
